import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import MeetingModalityService from "../../../../Services/MeetingModality.service";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import { getMeetingModalityDetailPath } from "./MeetingModalityRoutes";
const PAGE_SIZE = 50;
const MeetingModalityListTable = () => {
    var _a, _b;
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No meeting modalities found",
        rowVerticalPadding: 2,
        getData: (sort, pageNumber) => {
            return MeetingModalityService.search({}, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        initialSort: { sort: "MEETING_MODALITY_NAME", order: "asc" },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "Name",
                sortId: "MEETING_MODALITY_NAME",
            },
            {
                title: "Active",
                sortId: "MEETING_MODALITY_ACTIVE",
            },
        ],
        rows: ({ data }) => data.map((meetingModality, index) => {
            return [
                _jsx(Link, { to: getMeetingModalityDetailPath(meetingModality.id), children: meetingModality.name }, index),
                _jsx(BooleanDisplay, { val: meetingModality.active }, index),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs("h1", { className: "mb-3", children: ["Meeting Modalities", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) ? `(${(_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total})` : ""] }), _jsx("div", { className: "text-muted mb-2", children: "Meeting modality is a feature of SS&E's new meeting scheduler. Modalities are not available to the legacy scheduler, but when activated, they will appear throughout the new scheduler." }), _jsx("div", { className: "py-2", children: table })] }));
};
const MeetingModalityList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(MeetingModalityListTable, {}) }));
};
export default MeetingModalityList;
